export enum TextComparison {
  is = 0,
  isNot = 1,
  contains = 2,
  doesNotContain = 3,
  startsWith = 4,
  doesNotStartWith = 5,
  endsWith = 6,
  doesNotEndWith = 7,
  isUpdated = 8,
  was = 9,
  wasNot=10,
  isBlank = 11,
  isPresent = 12,
}